import React, {useState, useRef, useEffect} from 'react'
import { Breadcrumb , BreadcrumbHome, BreadcrumbItem } from "@wfp/ui";
import { useParams,useNavigate, NavLink } from 'react-router-dom';
import  ListControlByUser  from '../../controllers/ListControlByUser';
import { SingleControl } from '../../controllers/SingleControl';
import { MainData } from '../ui/MainData';
import { TailSpin } from "react-loader-spinner";
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../actions/auth';

// Home to display "Preguntas"
export const QuestionsScreen = () => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const query = 0;
    const [imgCourse, setImgCourse] = useState("");
    const [nameUnit, setNameUnit] = useState("");
    const limit = 1000;
    const { chapterId } = useParams();
    localStorage.setItem('chapterId',chapterId);
    const path = 'chapter/questions';
    const pathType = 'chapter_id';
    const course = (localStorage.getItem('course'))?JSON.parse(localStorage.getItem('course')):'';
    const unitId = (localStorage.getItem('unitId'))?JSON.parse(localStorage.getItem('unitId')):'';
    const lessonId = (localStorage.getItem('lessonId'))?JSON.parse(localStorage.getItem('lessonId')):'';
    const loader = useRef(null);
    let user = useSelector( state => state.auth );
    const token = useSelector((state) => state.ui.token);
    if(!user?.id){
        if(sessionStorage.getItem('userSelect') && token){
            user = JSON.parse(sessionStorage.getItem('userSelect'));
        }
        else{
            dispatch(logout(token));
            history( '/auth/', {
            replace: true
            });
        }
    }
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [list, setList] = useState([]);

    const data = ListControlByUser(query, limit, path, pathType, chapterId);
    useEffect(() => {
        if(data!==null){
            if(data.error===null){
                setLoading(data.loading)
                setList(data.data)
            }
            else{
                console.error(data.error)
                setError(data.error)
                // dispatch(logout(token));
                history.replace('/auth/login');
            }
            
        }
        
    }, [data,dispatch,history])

    useEffect(() => {
        if(loading===false){
            const pathC = 'lesson/chapter';
            const pathTypeC = 'id';
            const listUnit = SingleControl(0, limit, pathC, pathTypeC, unitId, user);
            listUnit.then((e)=>{
                    setImgCourse(process.env.REACT_APP_ADMIN_URL+e.image_chapter)
                    setNameUnit(e.name_unit)
                }
            ).catch((error) => {
                    console.error(error)
                    // dispatch(logout(token));
                    history.replace('/auth/login');
                }
            );
        }
        
    }, [loading])

    if(course===''){
        history.replace('/home');
    }

    const disCourse = ()=>{
        let lists = list;
        localStorage.setItem('Questions',JSON.stringify(lists));
        let count = lists.find((course) => {
                        if(course.state_name==='activo'){
                            if(course.type_question.name_type_question!=='informativo'){
                                if(course.status_approved==="pendiente"){
                                    return course;
                                }
                            }
                            
                        }       
                    });
                    
        if(count === undefined){
            count={id:0};
        }
        return lists.map((course) => (
            (course.state_name==='activo') ?
                    <MainData 
                    key={course.id}
                    id={course.id}
                    count_id={count.id}
                    name={course.name_question}
                    status_approved={(course.status_approved!=='pendiente')?course.status_approved:(course.type_question.name_type_question==='informativo')?'informativo':course.status_approved}
                    url="question" />
                    :null
                ));
        
    }
    
    return (
        <div className="content">
            <div className="text-title">{course && course.name_course}</div>

            
            <div className="fund-main-question">
            <div className="title-unit">{nameUnit}</div>
                <Breadcrumb>
                    <BreadcrumbItem>
                        <NavLink to="/home" className="wfp--link">
                        <BreadcrumbHome />
                        </NavLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem disableLink>
                    <NavLink to={`/lessons/${unitId}`} className="wfp--link">
                            Lecciones
                        </NavLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem>
                        <NavLink to={`/chapters/${lessonId}`} className="wfp--link">
                            Capitulos
                        </NavLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem disableLink>
                        Preguntas
                    </BreadcrumbItem>
                </Breadcrumb>
                <div className="content-lessons" >
                {loading && <div className="loader-page"><TailSpin
                    color="#00BFFF"
                    height={200}
                    width={200}
                />
                </div>}    
                {!loading && <div className="circular--landscape">
                    <img src={imgCourse} alt={course.name_course} className="img-unit1" />
                </div>}
 
                <div className="container-ulc">
                    {list && disCourse() }
                </div>
                
                </div>

                {error && <p>Error!</p>}
                <div ref={loader} />
            </div>
        </div>
    )
}

